export default "__VITE_ASSET__Bjsew5BE__"